export default __webpack_public_path__ + "static/media/perpetuum-ph.c0731d59.webp";